import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Win = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const winSound = new Audio("/win.mp3");
    winSound.play();
  }, []);

  const handleHomeButtonClick = () => {
    const sound = new Audio("/confirm.mp3");
    sound.onended = () => {
      navigate("/"); // Navigate to the home page using React Router
    };
    sound.play();
  };

  return (
    <div className="card">
      <h1 className="title">Congratulations! </h1>
      <p className="subtitle">You have the same brain!</p>
      <div className="button-group">
        <button id="homeButton" onClick={handleHomeButtonClick} className="button">
          Back to home
        </button>
      </div>
    </div>
  );
};

export default Win;
